import React, { useState, useEffect } from "react";
import {
  Stack,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableCell,
} from "@mui/material";
//Srcs
import ListExpense from "./ListExpense";

export default function ExpenseListComp({
  mainItem,
  disbursementList,
  setDisbursementList,
  requireField,
  setRequireField,
}) {
  // ======================= Resize width Screen =======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);
  // ======================= End Resize width Screen ======================

  return (
    <div>
      <Stack
        sx={{
          borderBottom: "1px solid #0f81c2",
          width: "100%",
          marginTop: "10px",
        }}
        direction="row"
        justifyContent="space-between"
      >
        <Typography className="field-title-sub-kh">ចំណាយ</Typography>
      </Stack>

      <TableContainer sx={{ maxWidth: `${width}px` }}>
        <Table className="list-table-disbursement" aria-label="simple table">
          <TableHead className="disbursement-header-row">
            <TableCell
              className="disbursement-header-title"
              sx={{ width: "10%" }}
            >
              INV N°
            </TableCell>
            <TableCell
              className="disbursement-header-title"
              sx={{ width: "10%" }}
            >
              កាលបរិច្ឆេទ
            </TableCell>
            <TableCell
              className="disbursement-header-title"
              sx={{ width: "22%" }}
            >
              បរិយាយ
            </TableCell>
            <TableCell
              className="disbursement-header-title"
              sx={{ width: "18%" }}
            >
              អ្នកផ្គត់ផ្គង់
            </TableCell>
            <TableCell
              className="disbursement-header-title"
              sx={{ width: "5%" }}
            >
              ចំនួន
            </TableCell>
            <TableCell
              className="disbursement-header-title"
              sx={{ width: "10%" }}
            >
              អត្រា​ប្តូ​រ​ប្រាក់
            </TableCell>
            <TableCell
              className="disbursement-header-title"
              sx={{ width: "10%" }}
            >
              លុយខ្មែរ
            </TableCell>
            <TableCell
              className="disbursement-header-title"
              sx={{ width: "10%" }}
            >
              លុយដុល្លារ
            </TableCell>
            <TableCell
              className="disbursement-header-title"
              sx={{ width: "5%" }}
            ></TableCell>
          </TableHead>

          <TableBody className="body">
            <ListExpense
              mainItem={mainItem}
              disbursementList={disbursementList}
              setDisbursementList={setDisbursementList}
              requireField={requireField}
              setRequireField={setRequireField}
            />
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
